import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the window back to the top on every route change. Without this,
// react-router keeps the previous scroll position, so opening a category or
// product page lands the user mid-page instead of at the top.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
